import { createApi } from "@reduxjs/toolkit/query/react";
import { ExternalYieldVault } from "@bridgesplit/abf-sdk";

import { ROUTE_GET_EXTERNAL_YIELD_INFO, ROUTE_GET_PAUSED_EXTERNAL_YIELD_SOURCES } from "../constants";
import { abfSerializeQueryArgs, marketsPublicBaseQuery } from "./util";

const EXTERNAL_YIELD_API = "ExternalYield";
const USER_MARGINFI_TAG = "UserMarginFi";

export const externalYieldApi = createApi({
    reducerPath: "externalYieldApi",
    baseQuery: marketsPublicBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,
    tagTypes: [EXTERNAL_YIELD_API, USER_MARGINFI_TAG],
    endpoints: (builder) => ({
        externalYieldInfo: builder.query<ExternalYieldVault[], void>({
            query() {
                return {
                    url: ROUTE_GET_EXTERNAL_YIELD_INFO,
                    method: "GET"
                };
            }
        }),
        pausedExternalYieldSources: builder.query<number[], void>({
            providesTags: [EXTERNAL_YIELD_API],
            query() {
                return {
                    url: ROUTE_GET_PAUSED_EXTERNAL_YIELD_SOURCES,
                    method: "GET"
                };
            }
        })
    })
});

export const { useExternalYieldInfoQuery, usePausedExternalYieldSourcesQuery } = externalYieldApi;
